<script>
export default {
  props: {
    historico: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      activeStep: this.historico?.length ? this.historico.length - 1 : 0
    }
  }
}
</script>

<template>
  <div>
    <div v-if="historico.length === 0" style="display: flex; justify-content: center;">
      <span>Não há histórico registrado.</span>
    </div>
    <div v-else>
      <el-steps direction="vertical" class="steps" :active="activeStep">
        <el-step
          :title="h.setor"
          v-for="(h, index) in historico"
          :key="index"
          @click.native="() => activeStep = index"
          class="step active-step">
          <template slot="icon">
            <p class="date-pad">{{ h.acoes[0].dataTramitacao.split(' ')[0] }}</p>
            <span class="circle"></span>
          </template>
          <template slot="description" v-if="activeStep === index">
            <div class="container-informacoes">
              <p v-for="(acao, i) in h.acoes" :key="i" class="descricao">
                {{ acao.dataTramitacao }} - {{ acao.descricao }}
              </p>
            </div>
          </template>
        </el-step>
      </el-steps>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Historico/Historico.vue